import React, { useState } from "react";
import { useUniqueId } from "shared/uniqueId/useUniqueId";

import { useTranslation } from "shared/i18n/useTranslation";
import { useFetchJson } from "shared/fetch/useFetchJson";
import { FetchJsonReturnType } from "shared/fetch/fetchJson";
interface ForgotPasswordType {
  handleSubmit?: (e: React.SyntheticEvent) => void;
  handleSuccess?: (response: FetchJsonReturnType<void>) => void;
  handleError?: (error: FetchJsonReturnType<void>) => void;
}

export function ForgotPassword({
  handleSubmit,
  handleSuccess,
  handleError,
}: ForgotPasswordType) {
  const { translate } = useTranslation();
  const { uid: getUniqueId } = useUniqueId("ForgotPassword");
  const [emailAddress, setEmailAddress] = useState("");
  const { run, isRunning } = useFetchJson<void>();
  function handleOnChange(e: React.ChangeEvent<HTMLInputElement>) {
    setEmailAddress(e.target.value);
  }

  async function handleForgotPasswordSubmit(
    e: React.SyntheticEvent
  ): Promise<void> {
    e.preventDefault();
    try {
      const response = await run("/auth/api/ForgotPassword", {
        method: "post",
        body: {
          email: emailAddress,
          passwordResetLink: `${window.location.host}/resetPassword?token=\${token}&email=\${email}`,
        },
      });
      if (handleSuccess) handleSuccess(response);
    } catch (error: any) {
      if (handleError) handleError(error);
      else throw error;
    }
  }

  return (
    <form onSubmit={handleSubmit ?? handleForgotPasswordSubmit}>
      <div className="mb-3">
        <label htmlFor={getUniqueId("email")} className="form-label">
          {translate("__email")}
        </label>
        <input
          type="email"
          className="form-control"
          autoComplete="username"
          id={getUniqueId("email")}
          onChange={handleOnChange}
          value={emailAddress}
        />
      </div>

      <button type="submit" className="btn btn-primary" disabled={isRunning}>
        {translate("__submit")}
      </button>
      <a href="login" className={`d-block text-center mt-3 `}>
        {translate("__doYouKnowYourPassword")}
      </a>
    </form>
  );
}
